import { render } from "./Ddd.vue?vue&type=template&id=277e5657"
import script from "./Ddd.vue?vue&type=script&lang=js"
export * from "./Ddd.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rnedkov/Documents/GitHub/cleaner-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__